import React from 'react';
import { ICardsCarouselProps } from './CardsCarouselV2.types';
import { useCardsCarouselStyles } from './CardsCarouselV2.styles';
import { RoleCard } from '../RoleCardV2/RoleCardV2';

export const CardsCarousel = (props: ICardsCarouselProps) => {
  const { roleCards, homePageStyle } = props;
  const styles = useCardsCarouselStyles();
  return (
    <ul className={homePageStyle ? styles.homepageStack : styles.stack}>
      {roleCards?.map((roleCard) => (
        <li key={roleCard.name} className={homePageStyle ? styles.homepageStackitem : styles.stackitem}>
          <RoleCard
            roleData={roleCard}
            homePageStyle={homePageStyle}
            isCurrentRole={props.currentUserRole == roleCard.name}
          />
        </li>
      ))}
    </ul>
  );
};
